// extracted by mini-css-extract-plugin
export default {"container":"LeitfadenDownload_container__1thuW","text":"LeitfadenDownload_text__6UKD7","contactBtn":"LeitfadenDownload_contactBtn__tB5IU","space":"LeitfadenDownload_space__04SNP"};